var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 5.90137V7.90137H15V5.90137H19ZM9 5.90137V11.9014H5V5.90137H9ZM19 13.9014V19.9014H15V13.9014H19ZM9 17.9014V19.9014H5V17.9014H9ZM21 3.90137H13V9.90137H21V3.90137ZM11 3.90137H3V13.9014H11V3.90137ZM21 11.9014H13V21.9014H21V11.9014ZM11 15.9014H3V21.9014H11V15.9014Z",
    fill: "#71839B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/dashboard.3bd3120a32468efc63ec5136df731e6e.svg";
export { ForwardRef as ReactComponent };